import View from './View';

function Edit(props) {
  return <div>this component is not editable</div>;
}

export default Edit;
